var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.657715,
    width: 24,
    height: 2.52632,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8.23682,
    width: 24,
    height: 2.52632,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 15.8154,
    width: 24,
    height: 2.52632,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.a9a353cb55ed05be4a39dbf66be74204.svg";
export { ForwardRef as ReactComponent };